import { customList as customCountryList, CountryProperty } from "country-codes-list";

// country-codes-list has problems with types so lots of workarounds below :-(
const callingCodesByCountry = customCountryList(
  "countryCode" as CountryProperty, // CountryProperty.countryCode causes "TypeError: Cannot read properties of undefined (reading 'countryCode')" in browser
  "+{countryCallingCode}" // `+{${CountryProperty.countryCallingCode}}` causes "TypeError: Cannot read properties of undefined (reading 'countryCallingCode')" in browser
) as { [key: string]: string }; // Default return type is wrong

// Remove some non-countries that make country calling codes ambiguous
delete callingCodesByCountry.AX; // Åland Islands (FI)
delete callingCodesByCountry.BV; // Bouvet Island (NO)
delete callingCodesByCountry.GG; // Guernsey (GB)
delete callingCodesByCountry.IM; // Isle of Man (GB)
delete callingCodesByCountry.JE; // Jersey (GB)

export interface IPhoneNumberInfo {
  countryCode: string; // "FI"
  countryCallingCode: string; // "+358"
  phoneNumberWithoutCountryCallingCode: string;
}

export const getPhoneNumberInfo = (
  phoneNumber: string,
  defaultCountryCode: string
): IPhoneNumberInfo => {
  const matchingEntries = Object.entries(callingCodesByCountry).filter((entry) =>
    phoneNumber.startsWith(entry[1])
  );
  if (
    matchingEntries.length > 1 &&
    matchingEntries.find((entry) => entry[0] === defaultCountryCode)
  ) {
    // Calling code is used in multiple countries and one of them is the defaultCountry
    const countryCallingCode = matchingEntries[0][1];
    return {
      countryCode: defaultCountryCode,
      countryCallingCode,
      phoneNumberWithoutCountryCallingCode: phoneNumber.substring(countryCallingCode.length),
    };
  } else if (matchingEntries.length === 1) {
    // Calling code matches single country
    const countryCallingCode = matchingEntries[0][1];
    return {
      countryCode: matchingEntries[0][0],
      countryCallingCode,
      phoneNumberWithoutCountryCallingCode: phoneNumber.substring(countryCallingCode.length),
    };
  } else {
    // Cannot detect unambiguous country from phoneNumber
    return {
      countryCode: defaultCountryCode,
      countryCallingCode: callingCodesByCountry[defaultCountryCode],
      phoneNumberWithoutCountryCallingCode: "",
    };
  }
};
